const { info, debug, warn, error } = console

const logger = {
  debug,
  info,
  warn,
  error
}
export default logger
